import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrustamiWidget from '@/components/Base/TrustamiWidget.vue';
export default defineComponent({
    name: 'artikelnummer-trustpilot-stueckzahl',
    components: { TrustamiWidget },
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
});
